import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const ContentContext = createContext();

export function ContentProvider({ children }) {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchContent = async () => {
    try {
      // Use full URL since this is called before axios baseURL might be set
      const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
      const response = await axios.get(`${backendUrl}/api/content-strings`);
      setContent(response.data.strings || {});
    } catch (error) {
      console.error('Failed to fetch content strings:', error);
      // Use empty object if fetch fails
      setContent({});
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const updateContent = (newContent) => {
    setContent(newContent);
  };

  // Helper function to get a string with fallback and parameter replacement
  const t = (key, fallback = key, params = {}) => {
    let text = content[key] || fallback;
    
    // Replace parameters like {count}, {size}, {qty}, etc.
    if (params && typeof params === 'object') {
      Object.keys(params).forEach(paramKey => {
        const regex = new RegExp(`\\{${paramKey}\\}`, 'g');
        text = text.replace(regex, params[paramKey]);
      });
    }
    
    return text;
  };

  return (
    <ContentContext.Provider value={{ content, t, updateContent, loading, fetchContent }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  const context = useContext(ContentContext);
  if (!context) {
    throw new Error('useContent must be used within ContentProvider');
  }
  return context;
}
